import { Component, OnInit } from '@angular/core';
import { ChartData } from '../../../shared/charts/charts.model';
import * as shape from 'd3-shape';
import * as _ from 'lodash';
import moment from 'moment';
import { TransactionService } from '../../../transaction/transaction.service';
import { TransactionType } from 'common';

@Component({
    selector: 'ifb-total-draws-card-chart',
    templateUrl: './total-draws-card-chart.component.html',
    standalone: false
})
export class TotalDrawsCardChartComponent implements OnInit {

  chartData: ChartData = {
    view: [400, 330],
    options: {
      showLabels: true,
      animations: true,
      xAxis: true,
      yAxis: true,
      showYAxisLabel: false,
      showXAxisLabel: false,
      timeline: true,
      legend: true,
      legendTitle: 'Processed Date',
      legendPosition: 'below',
      tooltipCaption: 'Bucketed by processed date',
      colorScheme: {
        // One color per year, oldest -> newest. Years render ascending, so the
        // last two entries keep prior-year (blue) / current-year (green) as before;
        // the two new prior years get grey / orange from the dashboard palette.
        domain: ['#747474', '#e28f26', '#4a78bc', '#1c9b41']
      },
      barPadding: 2,
      curve: shape.curveCatmullRom
    }
  };

  constructor(private _transactionService: TransactionService) { }

  ngOnInit() {
    this.fetchData();
  }

  fetchData() {
    this._transactionService.groupedByYear({
      fromDate: moment().subtract(3, 'years').startOf('year').format('L'),
      type: [TransactionType.Draw],
    }).subscribe((data) => {
      let minTotalAmount = Number.MAX_SAFE_INTEGER;
      let maxTotalAmount = Number.MIN_SAFE_INTEGER;
      this.chartData.data = _.chain(data)
        .groupBy('year')
        .map((value, key) => ({
          name: key, series: _.map(value, function (item) {
            if(minTotalAmount > item.totalAmount) {
              minTotalAmount = item.totalAmount;
            }

            if(maxTotalAmount < item.totalAmount) {
              maxTotalAmount = item.totalAmount;
            }

            return { name: moment(item.month, 'MM').format('MMMM'), value: item.totalAmount };
          })
        }))
        .value();

      this.chartData.options.yScaleMin = minTotalAmount === Number.MAX_SAFE_INTEGER ? null : minTotalAmount * 0.9;
      this.chartData.options.yScaleMax = maxTotalAmount === Number.MIN_SAFE_INTEGER ? null : maxTotalAmount * 1.1;
    });
  }
}
